
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { InitInfo } from "@/utils/init-info";
import { getFileUrl } from "@/utils/url";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { AWSFileService } from "../../services/aws-file-service";

export default FormLike.extend({
	data() {
		return {
			uploadComplete: false,
			sending: false,
			fileUrl: "",
		};
	},
	props: {
		content: Object as () => InitInfo,
		controlsDisabled: Boolean
	},
	computed: {
		allowedExtensions(): string[] {
			return ["jpg", "png", "jpeg"];
		}
	},
	methods: {
		prev() {
			this.$emit("switch");
			this.$emit("prev");
		},
		next() {
			this.$emit("next");
		},
		skip() {
			this.content.logoToken = undefined;
			this.$emit("skip");
		},
		submit() {
			this.$emit("next");
		},
		async onInput(file: File) {
			if (file.type.indexOf("image") == -1) {
				this.$wf.notify(
					this.$ct("error-invalid-file-type"),
					"danger",
					3000,
					"exclamation-triangle"
				);
				return;
			}
			this.sending = true;
			let awsFile = await AWSFileService.uploadFile(
				"/print-layouts",
				file
			);

			this.content.logoToken = awsFile.Token;

			this.fileUrl = getFileUrl(this.content.logoToken);

			this.uploadComplete = true;
			this.sending = false;
		}
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.init-modal"
	}
});
